export default __webpack_public_path__ + "static/media/00.46d9c32e.jpg";